import { HttpClient } from '@opallabs/api'
import { loadJsonApiEntities } from '../loadJsonApiEntities'

const patchMoment = ({ id, params }) =>
  HttpClient().patch(`/moments/v2/${id}`, params)

const updateMoment =
  ({ momentId, update, callback, promise }) =>
  (dispatch) =>
    patchMoment({
      id: momentId.toString(),
      params: {
        data: {
          attributes: {
            ...update,
          },
          id: momentId,
          type: 'moment',
        },
      },
    })
      .then((response) => {
        const responseData = response.data
        if (callback) callback(promise, responseData.data)
        return dispatch(loadJsonApiEntities(responseData))
      })
      .catch((err) => {
        console.log(err)
        throw err
      })

export default updateMoment
